import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { find, pull } from 'lodash';
import { BaseControlComponent } from '../base/base-control.component';
import { SelectorService } from '../base/selector.service';

@Component({
  selector: 'ssg-tag-input',
  templateUrl: './tag-input.component.html',
  styleUrls: ['./tag-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagInputComponent extends BaseControlComponent<any>  {
  isshow: boolean;
  FirstBackspace: boolean = false;
  @ViewChild('tagInput') tagInputRef: ElementRef;
  _tags: string[] = [];
  get tags(): string[] {
    if (this.f[this.name].value) {
      this._tags = this.f[this.name].value.toString().split(',');
      return this.f[this.name].value.toString().split(',');
    }
    else {
      this._tags = [];
      return [];
    }
  }

  form: UntypedFormGroup;
  constructor(private fb: UntypedFormBuilder, protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  ngOnInit() {
    super.ngOnInit();
    this.form = this.fb.group({
      tag: [undefined],
    });
    if (this.f[this.name] && this.f[this.name].value && this.f[this.name].value.length > 0) {
      this.f[this.name].value.forEach(x => { this._tags.push(x); });
    }
  }
  focusTagInput(): void {
    this.tagInputRef.nativeElement.focus();
  }

  onKeyUp(event: KeyboardEvent): void {
   this.cd.markForCheck();
    const inputValue: string = this.form.controls.tag.value;
    if (!this.FirstBackspace && !inputValue)
      this.FirstBackspace = true;
    else
      this.FirstBackspace = false;
    if (event.code === 'Backspace' && !this.FirstBackspace && !inputValue) {
      this.removeTag();
      return;
    } else {
      if ((event.code === 'Comma' && event.key !== "و") || (event.ctrlKey && event.code === "Space")) {
        this.addTag(inputValue);
        this.form.controls.tag.setValue('');
      }
    }
    if (this._tags && this._tags.length > 0)
      this.f[this.name].setValue(this._tags);
    else
      this.f[this.name].setValue(undefined);
  }

  addTag(tag: string): void {
    if (tag[tag.length - 1] === ',' || tag[tag.length - 1] === ' ') {
      tag = tag.slice(0, -1);
    }
    if (tag.length > 0 && !find(this._tags, tag)) {
      this._tags.push(tag);
    }
  }

  removeTag(tag?: string): void {
    if (!!tag) {
      pull(this._tags, tag);
    } else {
      this._tags.splice(-1);
    }
    if (this._tags && this._tags.length > 0)
      this.f[this.name].setValue(this._tags.join(","));
    else
      this.f[this.name].setValue("");
  }
}
